import L from "leaflet";
import { CanvasPinMarker } from "./canvasPin/CanvasPinMarker";

/**
 * 地図に載っているピンの地点をすべて返す。
 * 画像のピン（L.Marker）と Canvas に描いたピン（CanvasPinMarker）の両方を対象にする。
 */
export const collectPinLatLngs = (map: L.Map): L.LatLng[] => {
  const latLngs: L.LatLng[] = [];
  map.eachLayer((layer) => {
    if (layer instanceof L.Marker || layer instanceof CanvasPinMarker) {
      latLngs.push(layer.getLatLng());
    }
  });
  return latLngs;
};
